import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const PARAMOUNT_PROMO_CODE = "2022PARAMOUNTP1" 

export const ParamountGetStartedComponent = () => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(PARAMOUNT_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({disabled, handleClick}) => {
    return (
      <> 
        <Button
        type="button"
        className="btn"
        primary
        disabled={disabled}
        onClick={() => {
          setSubmissionPromoCode(promoCode)
          handleClick()
        }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(
      PARAMOUNT_PROMO_CODE
    )
  ];

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <p>T-Mobile for Business, T-Mobile Home Internet only, or Sprint customers, enter your T-Mobile or Sprint phone number to begin the redemption process. You will then be prompted to log in to your account.</p>
            <p>If you are a Home Internet only customer, please find your assigned billing phone number on your bill under "connected devices".</p>
            <p>Offer for Paramount+ Essential monthly plan only. Offer cannot be combined with any other Paramount+ offers, bundles, discounts, 
              or coupons. Subscriber account registration and credit card required. <b>Automatic charges apply at end of offer period.</b>
            </p>
            <img style={{marginTop: "1rem"}} src={"images/Paramount/paramount_logo.jpg"} alt="Paramount Logo" className="mb-3"/>
            <p>
              Get One Year of the Paramount+ Essential monthly plan—On Us! 
              Stream live sports, breaking news, thousands of movies and over 30,000 episodes. Watch on up to 3 devices and create separate profiles for the whole family! 
            </p>
            <p>If you are a T-Mobile for Business customer, please click "<a href={process.env.REACT_APP_TMO_TFB_ID_AUTH_URL} rel="noreferrer">Here</a>".</p>
            <p><span className="magenta">Already a Paramount+ subscriber?</span> Click <a href="https://www.t-mobile.com/offers/paramount-plus-deal#paramount-plus-faq" target="_blank" rel="noopener noreferrer">here</a> before you redeem your offer from T-Mobile.</p>
            <p><span className="magenta">T-Mobile postpaid consumer voice customers ready to add Paramount+,</span> click <a href="https://www.t-mobile.com/account/benefit-redemption/paramountplus" target="_blank" rel="noopener noreferrer">here</a> to login and add your offer.</p>
          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{marginBottom: "6px"}}>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto"/>
        </div>
        <div className="mx-auto col-md-4">   
          <p>
            Questions before you continue?
            Find answers <a href="https://www.t-mobile.com/offers/paramount-plus-deal#paramount-plus-faq" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
        </div>
      </div>
    </section>
  )
}
